import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectLeadsListItems } from "../../../../../redux/leads/selector";
import { leads } from "../../../../../redux/leads/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";

const ManagementLeads = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectLeadsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'LeadInfo.Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'LeadInfo.Email', headerName: 'Email' },
      { field: 'LeadInfo.PhoneNumber', headerName: 'Phone Number', sortable: true, filter: true },
      { field: 'LeadInfo.MobilityProductName', headerName: 'Product Name' },
      { field: 'CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },
    ]);
  }
  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const handleDelete = async (data: any) => {
    await dispatch(leads.delete({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/leads/delete`,
      entity: 'leads',
      jsonData: {
        Records: [
          {

            Id: data?.Id


          }
        ]
      }
    }))
    await fetchLeads()
  }
  const fetchLeads = async () => {
    await dispatch(leads.resetAction({ actionType: 'list' }))
    await dispatch(leads.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/leads/list`, entity: 'leads', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",

      }
    }))
  }
  useEffect(() => {
    createColumnDefs()
    fetchLeads()
  }, [pageData, pageSize])

  const handleReloadData = () => {
    fetchLeads()
  }

  const additionButtons: any = [
    // {
    //   name: 'Add Leads',
    //   callback: () => handleAdd(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];
  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(leads.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/leads/list`,
      entity: 'leads',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }
  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          onSearch={handleSearch}
          enableFilter={true}
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          onEdit={handleEdit}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          headingName="Leads" />
      }
    </>

  );
};

export default ManagementLeads;


